export default "__VITE_ASSET__CqRNkddY__"